import { FormControl, FormControlLabel, FormLabel, Grid, MenuItem, Radio, RadioGroup, TextField, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../../app/hooks";
import { selectScheduleInsUpd, scheduleInsUpdSlice } from "../../../../redux/curriculum/scheduleInsUpdSlice";
import { isValidTime, SubjectInfo, timeToMinutes } from "../../../../redux/curriculum/model";
import { selectSubjectList } from "../../../../redux/curriculum/subjectListSlice";

const weekDays = [
    { value: 0, label: "Dom" },
    { value: 1, label: "Seg" },
    { value: 2, label: "Ter" },
    { value: 3, label: "Qua" },
    { value: 4, label: "Qui" },
    { value: 5, label: "Sex" },
    { value: 6, label: "Sáb" },
];

export interface ScheduleInsUpdDataProps {
    subjects: SubjectInfo[];
}

export function ScheduleInsUpdData() {
    const scheduleInsUpd = useSelector(selectScheduleInsUpd);
    const subjects = useSelector(selectSubjectList);
    const dispatch = useAppDispatch();

    const setValue = (key: "subjectId" | "dayOfWeek" | "startTime" | "endTime", value: string | number) => {
        const schedule = {
            ...scheduleInsUpd.schedule,
            [key]: value,
        };
        dispatch(scheduleInsUpdSlice.actions.set(schedule));
    };

    return <>
        <Typography variant="h6" gutterBottom>
            Dados do horário
        </Typography>
        <Grid container spacing={3}>
            <Grid size={12}>
                <TextField
                    required
                    id="subjectId"
                    name="subjectId"
                    label="Disciplina"
                    select
                    fullWidth
                    variant="standard"
                    error={scheduleInsUpd.schedule.subjectId <= 0}
                    value={scheduleInsUpd.schedule.subjectId || ""}
                    onChange={(e) => setValue("subjectId", e.target.value)}
                >
                    {(subjects.list || []).map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                            {item.name}
                        </MenuItem>
                    ))}
                </TextField>
            </Grid>
            <Grid size={12}>
                <FormControl required>
                    <FormLabel id="dayOfWeek-label">Dia da Semana</FormLabel>
                    <RadioGroup
                        row
                        aria-labelledby="dayOfWeek-label"
                        name="dayOfWeek"
                        value={`${scheduleInsUpd.schedule.dayOfWeek}`}
                        onChange={(e) => setValue("dayOfWeek", Number(e.target.value))}
                    >
                        {weekDays.map((day) => (
                            <FormControlLabel key={day.value} value={`${day.value}`} control={<Radio />} label={day.label} />
                        ))}
                    </RadioGroup>
                </FormControl>
            </Grid>
            <Grid size={6}>
                <TextField required id="startTime" name="startTime" label="Início"
                    fullWidth variant="standard"
                    placeholder="08:00"
                    error={isValidTime(scheduleInsUpd.schedule.startTime) && isValidTime(scheduleInsUpd.schedule.endTime) && timeToMinutes(scheduleInsUpd.schedule.startTime) >= timeToMinutes(scheduleInsUpd.schedule.endTime)}
                    value={scheduleInsUpd.schedule.startTime}
                    onChange={(e) => setValue("startTime", e.target.value)} />
            </Grid>
            <Grid size={6}>
                <TextField required id="endTime" name="endTime" label="Fim"
                    fullWidth variant="standard"
                    placeholder="09:00"
                    error={isValidTime(scheduleInsUpd.schedule.startTime) && isValidTime(scheduleInsUpd.schedule.endTime) && timeToMinutes(scheduleInsUpd.schedule.startTime) >= timeToMinutes(scheduleInsUpd.schedule.endTime)}
                    value={scheduleInsUpd.schedule.endTime}
                    onChange={(e) => setValue("endTime", e.target.value)} />
            </Grid>
        </Grid>
    </>;
}
